import { handleAxiosAuthError } from '../utils/AxiosErrorHandling'; 
import axios from 'axios';

const BASE_API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000';
const AUTH_URL = `${BASE_API_URL}/api/v1/auth/`;

// ----------------------------------------------------------------------
// 🔒 توابع داخلی (Helper)
// ----------------------------------------------------------------------
const setAuthData = ({ token, refresh_token, user_info, remember_me = false }) => {
    // 🟢 برای جلوگیری از لوپ لاگین، توکن‌ها همیشه در localStorage ذخیره شوند
    // (بدون توجه به remember_me)
    const storage = localStorage;   // ← تغییر اصلی
    
    if (token) {
        storage.setItem('access_token', token);
        if (refresh_token) storage.setItem('refresh_token', refresh_token);
    }
    
    if (user_info) {
        storage.setItem('user', JSON.stringify(user_info));
        storage.setItem('userId', user_info.id);
        if (user_info.phone_number) storage.setItem('phoneNumber', user_info.phone_number);
    }
    
    // ⛔️ حذف تاریخ انقضای دستی – خود JWT دارای exp است
};

const clearAuthData = () => {
    [localStorage, sessionStorage].forEach(storage => {
        ['access_token', 'refresh_token', 'user', 'userId', 'phoneNumber'].forEach(key => storage.removeItem(key));
    });
};

const getAuthTokens = () => {
    // بررسی localStorage سپس sessionStorage (برای سازگاری با نسخه‌های قدیمی)
    let token = localStorage.getItem('access_token');
    if (token) return token;
    return sessionStorage.getItem('access_token');
};

// ----------------------------------------------------------------------
// 🔐 متدهای اصلی احراز هویت (بدون تغییر)
// ----------------------------------------------------------------------

const loginUser = async (identifier, password, remember_me = false) => {
    try {
        const response = await axios.post(`${AUTH_URL}login/`, { 
            identifier, 
            password 
        });

        const { access, refresh, user_id, identifier: userLabel } = response.data; 

        setAuthData({ 
            token: access, 
            refresh_token: refresh,
            user_info: { 
                id: user_id, 
                identifier: userLabel 
            }, 
            remember_me 
        });
        
        return { id: user_id, identifier: userLabel };
    } catch (error) {
        throw handleAxiosAuthError(error, 'login');
    }
};

const registerUser = async (phone_number, email, password, full_name = '') => {
    try {
        const payload = {
            password: password,
            full_name: full_name ? String(full_name).trim() : "",
            phone_number: phone_number && phone_number.trim() !== "" ? phone_number.trim() : null,
            email: email && email.trim() !== "" ? email.trim() : null
        };

        const response = await axios.post(`${AUTH_URL}register/`, payload);
        return response.data;

    } catch (error) {
        console.error("Registration Backend Error:", error.response?.data);
        throw handleAxiosAuthError(error, 'register');
    }
};

const requestPasswordReset = async (identifier) => {
    try {
        const response = await axios.post(`${AUTH_URL}password-reset/request/`, { identifier });
        return response.data;
    } catch (error) {
        throw handleAxiosAuthError(error, 'general');
    }
};

const confirmPasswordReset = async ({ identifier, otp_code, password }) => {
    try {
        const response = await axios.post(`${AUTH_URL}password-reset/confirm/`, {
            identifier, 
            otp_code,
            password, 
            password2: password, 
        });
        return response.data;
    } catch (error) {
        throw handleAxiosAuthError(error, 'general');
    }
};

const logout = () => {
    clearAuthData();
};

// 🎯 Export (بدون تغییر)
const authService = {
    loginUser,
    registerUser,
    logout,
    requestPasswordReset,
    confirmPasswordReset,
    getAuthTokens,
    setAuthData,
    clearAuthData,
    getUserInfo: () => {
        const user = localStorage.getItem('user') || sessionStorage.getItem('user');
        return user ? JSON.parse(user) : null;
    },
    isAuthenticated: () => !!getAuthTokens(),
};

export default authService;